import { Observable } from 'rxjs';
import { Apollo } from 'apollo-angular';
import { ApolloQueryResult } from '@apollo/client/core';

class Resolver {
  private subscriptionForQuery;
  private subscriber;

  constructor(
    private apollo: Apollo,
    private variables,
    private listQuery,
    private subscriptionQuery,
    private applyCallback,
  ) {}

  getResult() {
    return new Observable<any>((subscriber) => {
      const options: any = {
        query: this.listQuery,
        fetchPolicy: 'network-only',
      };
      if (this.variables) options.variables = this.variables;

      this.apollo.query(options).subscribe({
        next: (res: any) => {
          const list = res?.data?.task?.list;
          const gqlErr = list?.errors;
          if (gqlErr && (gqlErr.status && gqlErr.status !== 200)) {
            subscriber.error({
              status: gqlErr.status,
              message: gqlErr.message,
              errorData: gqlErr.errorData,
            });
            return;
          }
          subscriber.next(res);
        },
        error: (err) => {
          subscriber.error(err);
        },
        complete: () => subscriber.complete(),
      });
    });
  }
}

export abstract class FilteredListServiceBase<T> {
  constructor(public apollo: Apollo) {}

  getList(variables): Observable<ApolloQueryResult<T>> {
    const resolver = new Resolver(
      this.apollo,
      variables,
      this.getListQuery(),
      this.getMutationQuery(),
      this.applyNewData,
    );
    return resolver.getResult();
  }

  abstract getListQuery();

  abstract getMutationQuery();

  abstract applyNewData(newResult);
}
